export default {
  title: 'Companies',
};
